import { render, staticRenderFns } from "./ActivationNew2.vue?vue&type=template&id=0cbf011c&scoped=true&"
import script from "./ActivationNew2.vue?vue&type=script&lang=js&"
export * from "./ActivationNew2.vue?vue&type=script&lang=js&"
import style0 from "./ActivationNew2.vue?vue&type=style&index=0&id=0cbf011c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cbf011c",
  null
  
)

export default component.exports